// Function to map progress based on step and local progress

export function calculateAppWideProgress(step, localProgress, isSubprocess = false) {
    const progressMap = {
        "#process1#": [0, 52.53456221198157],
        "#process2#": [52.53456221198157, 79.26267281105991],
        "between23": [79.26267281105991, 84.94623655913979],
        "#process3#": [84.94623655913979, 90.62980030721967],
        "#theend#": [90.62980030721967, 100]
    };
    if (step === "#process1#") {
        // Subprocess proportions within #process1#
        const subprocessProportion = 0.6; // 60%
        const restOfProcess1Proportion = 0.4; // 40%
        
        // Adjust #process1# range to include the subprocess
        const process1Range = progressMap["#process1#"];
        const process1Start = process1Range[0];
        const process1End = process1Range[1];
        const process1Length = process1End - process1Start;

        const subprocessRange = [
            process1Start,
            process1Start + process1Length * subprocessProportion,
        ];
        const restOfProcess1Range = [
            subprocessRange[1],
            process1End,
        ];

        if (isSubprocess) {
            const range = subprocessRange;
            return Math.round(range[0] + (range[1] - range[0]) * localProgress / 100);
        } else {
            const range = restOfProcess1Range;
            return Math.round(range[0] + (range[1] - range[0]) * localProgress / 100);
        }
    } else {
        const range = progressMap[step];
        if (!range) throw new Error(`Unknown step: ${step}`);
        return Math.round(range[0] + (range[1] - range[0]) * localProgress / 100);
    }
}